import type { AddItemContext, CartStateGetSet } from "@/cart/types";
import { MATIC_BAG_PASS_VARIANT_ID } from "@/consts/shopify";

export const addAnnualBagPass = ({ get }: CartStateGetSet) => {
  return async (context?: AddItemContext) => {
    await get().addItem(MATIC_BAG_PASS_VARIANT_ID, context, 1);
    return get().cart;
  };
};
